/**
 * Masks an email for display, keeping a short prefix and suffix visible.
 *
 * @example
 * maskEmail('a@b.co') // -> 'a@***co'
 * maskEmail('verylongemailaddress@example.com') // -> 'very**********************le.com'
 */
export const maskEmail = (email: string) => {
  const visibleStart = Math.min(4, Math.floor(email.length / 3))
  const visibleEnd = Math.min(6, Math.floor(email.length / 3))
  const start = email.slice(0, visibleStart)
  const end = email.slice(-visibleEnd)
  const maskedLength = Math.max(email.length - visibleStart - visibleEnd, 3)
  return `${start}${'*'.repeat(maskedLength)}${end}`
}
